import {type DiscoveryNode} from '../discovery/index.ts';
import {getByName} from '../utils/network.ts';
import type {Logger} from '../logging.ts';

const DNS_RETRY = 5;

export abstract class KubernetesEndpointResolver {
    protected readonly logger: Logger;
    constructor(logger: Logger) {
        this.logger = logger;
    }
    async start() {
        // do nothing
    }

    abstract resolve(): Promise<DiscoveryNode[]>

    async close() {
        // do nothing
    }

    protected async mapAddress(address?: string) {
        if (!address) {
            return;
        }

        try {
            let retry = 0;
            try {
                return await getByName(address);
            } catch (e) {
                if (retry < DNS_RETRY) {
                    retry++;
                } else {
                    throw e;
                }
            }
        } catch (e) {
            // todo log address cloud not be resolved
        }

    }
}
